import { lazy, Suspense } from 'react'

import { Card } from '@procurify/ui'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const ReceivingSummaryViewChunk = lazy(() =>
  import('../../feature-sets/ReceivingSummaryView').then(
    ({ ReceivingSummaryView }) => ({
      default: ReceivingSummaryView,
    })
  )
)

export const ReceivingSummaryPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.receivingPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.receivingPageTitle),
        },
      ]}
    >
      <Card>
        <Card.Content>
          <Suspense fallback={null}>
            <ReceivingSummaryViewChunk />
          </Suspense>
        </Card.Content>
      </Card>
    </Page>
  )
}
